import { useState } from "react";
import { getBookingUrls } from "../services/api";

interface Props {
  showId: string;
  ticketUrl: string | null;
}

export function BookingButtons({ showId, ticketUrl }: Props) {
  const [loading, setLoading] = useState(false);

  async function handleBook() {
    setLoading(true);
    try {
      const urls = await getBookingUrls(showId);
      window.open(urls.ticket_url, "_blank");
      window.open(urls.flight_url, "_blank");
      window.open(urls.hotel_url, "_blank");
    } catch {
      if (ticketUrl) window.open(ticketUrl, "_blank");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex flex-wrap gap-2">
      <button
        onClick={handleBook}
        disabled={loading}
        className="rounded-lg bg-brand-600 px-4 py-2 text-sm font-semibold text-white hover:bg-brand-700 disabled:opacity-50"
      >
        {loading ? "Opening…" : "Book trip"}
      </button>
      {ticketUrl && (
        <a
          href={ticketUrl}
          target="_blank"
          rel="noreferrer"
          className="rounded-lg border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
        >
          Ticket only
        </a>
      )}
    </div>
  );
}
